// 配置录屏打点的自定义事件中文名称
export const eventNameMap = {
    'selectAll_true': '全选',
    'selectAll_false': '取消全选',
    'imgSaveEle': '图片保存到原料库',
    'imgSaveLib': '图片保存到投放库',
    'imgDelete': '图片删除',
    'imgPreview': '预览大图',
    'showInfoTip': '查看ID信息',
    'imgEdit': '图片编辑',
    'intelForm': '图片生成',
    'designForm': '模板添加'
};